import { colors } from 'hui';
import styled, { css } from 'styled-components';

export const HeaderCol = styled.div`
  box-sizing: border-box;
  display: block;
  flex: 0 0 auto;
  align-self: center;
`;

type NavLinkProps = { color?: string; size?: string };

export const NavLink = styled.a<NavLinkProps>`
  font-size: 15px;
  text-decoration: none;
  color: ${colors.tint1};
  padding: 10px 7px 10px;
  display: inline-block;
  &:hover,
  &:visited {
    color: #555;
  }

  ${props =>
    props.color &&
    css`
      color: ${colors[props.color]};
      &:hover,
      &:visited {
        color: ${colors[props.color]};
      }
    `};
  ${props =>
    props.size === 'bold' &&
    css`
      font-weight: bold;
    `};
`;